<template>
  <SidePopup
    :title="title"
    @close="onClose"
    routeback="/fornecedor/comercial/cupom-desconto"
  >
    <Grid grid-template-columns="repeat(3, 1fr)" grid-gap="20px">
      <div class="info-show md">
        <div class="info-label">Código do cupom</div>
        <div class="info-value">{{ cupom.codigocupom }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Origem</div>
        <div class="info-value" v-if="cupom.tipo === 1">Indicação</div>
        <div class="info-value" v-if="cupom.tipo === 2">Recompensa</div>
        <div class="info-value" v-if="cupom.tipo === 4">Cadastro</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Desconto</div>
        <div class="info-value" v-if="cupom.tipodesconto === '%'">
          {{ cupom.valordesconto }}{{ cupom.tipodesconto }}
        </div>
        <div
          class="info-value"
          v-if="cupom.tipodesconto === 'R$' || cupom.tipodesconto === '$'"
        >
          R$ {{ cupom.valordesconto }}
        </div>
      </div>
      <div class="info-show md" v-if="cupom.valor_teto">
        <div class="info-label">Teto do desconto</div>
        <div class="info-value">
          {{ cupom.valor_teto | formatMoney }}
        </div>
      </div>
      <div class="info-show md">
        <div class="info-label">Data inicio</div>
        <div class="info-value">{{ cupom.datainicio | formatDate }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Data fim</div>
        <div class="info-value" v-if="cupom.tipo === 4">
          {{ cupom.datafim | formatDate }}
        </div>
        <div class="info-value" v-if="cupom.tipo === 1">
          {{ "Não expira" }}
        </div>
      </div>
      <div class="info-show md">
        <div class="info-label">Usos</div>
        <div class="info-value">{{ cupom.qtd_max_por_cliente }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Utilizados</div>
        <div class="info-value">
          {{ cupom.qtd_uso }}/{{ cupom.qtd_max_uso || "-" }}
        </div>
      </div>
      <div class="info-show md" v-if="cupom.valor_min_pedido">
        <div class="info-label">Valor mínimo do pedido</div>
        <div class="info-value">
          {{ cupom.valor_min_pedido | formatMoney }}
        </div>
      </div>
      <div class="info-show md" v-if="cupom.valor_max_pedido">
        <div class="info-label">Valor máximo do pedido</div>
        <div class="info-value">
          {{ cupom.valor_max_pedido | formatMoney }}
        </div>
      </div>
      <div class="info-show md" v-if="cupom.valor_min_pedido_categoria">
        <div class="info-label">{{ labelsMinMaxCategoriaDetalhe.minimo }}</div>
        <div class="info-value">
          {{
            parseFloat(cupom.valor_min_pedido_categoria).toFixed(2)
              | formatMoney
          }}
        </div>
      </div>
      <div class="info-show md" v-if="cupom.valor_max_pedido_categoria">
        <div class="info-label">{{ labelsMinMaxCategoriaDetalhe.maximo }}</div>
        <div class="info-value">
          {{
            parseFloat(cupom.valor_max_pedido_categoria).toFixed(2)
              | formatMoney
          }}
        </div>
      </div>
      <div class="info-show md">
        <div class="info-label">Usa em promoções</div>
        <div class="info-value" v-if="cupom.nao_usar_com_politica">Não</div>
        <div class="info-value" v-if="!cupom.nao_usar_com_politica">Sim</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Canais de venda</div>
        <div class="info-value">{{ canaisDeVenda }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Clientes</div>
        <div
          class="info-value"
          v-if="!cupom.clientes || !cupom.clientes.length"
        >
          Qualquer cliente
        </div>
        <div
          class="info-value"
          v-else-if="cupom.clientes && cupom.clientes.length > 0"
        >
          Clientes selecionados
        </div>
      </div>
      <div class="info-show md">
        <div class="info-label">Categoria</div>
        <div class="info-value">{{ nomesCategorias }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Segmento do cliente</div>
        <div class="info-value">{{ cupom.nome_segmento }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Observações</div>
        <div class="info-value">{{ cupom.obs }}</div>
      </div>
      <div class="info-show md">
        <div class="info-label">Visualização de desconto</div>
        <div class="info-value">
          {{
            cupom.habilitar_visualizacao_desconto
              ? "Habilitado"
              : "Desabilitado"
          }}
        </div>
      </div>
      <div class="info-show md">
        <div class="info-label">Apresentar na lista de cupons do cliente</div>
        <div class="info-value">
          {{ cupom.exibir_cupom ? "Sim" : "Não" }}
        </div>
      </div>

      <div class="info-show md">
        <div class="info-label">Cupom de Aplicação Automática</div>
        <div class="info-value">
          {{ cupom.aplicacao_automatica ? "Sim" : "Não" }}
        </div>
      </div>

      <div class="info-show md">
        <div class="info-label">Cupom de primeira compra</div>
        <div class="info-value">
          {{ cupom.primeira_compra ? "Sim" : "Não" }}
        </div>
      </div>
    </Grid>
    <template v-if="cupom.clientes && cupom.clientes.length > 0">
      <LineDivider position="bottom">
        <h4>Clientes</h4>
      </LineDivider>

      <DataTable
        :headers="headers"
        :endpoint="endpoint('cliente')"
        :data="cupom.clientes"
        :items-length="cupom.clientes.length"
        sortBy="nome"
      >
        <template v-slot:descritor="{ col }">
          <span class="variable-descriptor">{{ col }}</span>
        </template>
      </DataTable>
    </template>

    <template
      v-if="cupom.formas_pagamento && cupom.formas_pagamento.length > 0"
    >
      <LineDivider position="bottom">
        <h4>Formas de pagamento</h4>
      </LineDivider>

      <DataTable
        :headers="headersPagamento"
        :endpoint="endpoint('pagamento')"
        :data="cupom.formas_pagamento"
        :items-length="cupom.formas_pagamento.length"
        sortBy="descricao"
      >
        <template v-slot:descritor="{ col }">
          <span class="variable-descriptor">{{ col }}</span>
        </template>
      </DataTable>
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import { CUPOM_DESCONTO_LOAD } from "@/store/actions/cupom";
import DataTable from "@/components/DataTable";
import LineDivider from "@/components/LineDivider";
import Grid from "@/components/Grid";
import { mapGetters } from "vuex";

export default {
  name: "CupomView",
  components: { SidePopup, DataTable, LineDivider, Grid },
  data: () => ({
    cupom: {
      clientes: [],
      codigocupom: "",
      valorDesconto: "",
      datainicio: "",
      datafim: "",
      obs: "",
      tipoCupom: "",
      qtd_max_uso: null,
      tipodesconto: "%",
      qtd_uso: 0,
      qtd_max_por_cliente: 1,
      nao_usar_com_politica: false,
      valordesconto: 0,
      vencido: false,
      aplicacao_automatica: false
    },
    headers: [
      {
        text: "CPF/CNPJ",
        value: "cpf",
        sortable: false,
        clickable: false
      },
      {
        text: "Nome",
        value: "nome",
        sortable: false,
        clickable: false
      },
      {
        text: "E-mail",
        value: "email",
        sortable: false,
        clickable: false
      }
    ],
    headersPagamento: [
      {
        text: "Forma de Pagamento",
        value: "descricao",
        sortable: true,
        clickable: true
      }
    ],
    title: "Detalhes cupom de desconto"
  }),
  computed: {
    ...mapGetters(["getFornecedorId"]),
    canaisDeVenda() {
      return (this.cupom.device || [])
        .join(",")
        .replace("APP", "Aplicativo")
        .replace("WEB", "Desktop")
        .replace("MANUAL", "Venda+");
    },
    nomesCategorias() {
      return this.extrairNomesCategorias(this.cupom).join(", ");
    },
    labelsMinMaxCategoriaDetalhe() {
      const multi = this.extrairNomesCategorias(this.cupom).length > 1;
      if (multi) {
        return {
          minimo: "Valor mínimo de pedidos nas categorias selecionadas",
          maximo: "Valor máximo de pedidos nas categorias selecionadas"
        };
      }
      return {
        minimo: "Valor mínimo de pedidos da categoria",
        maximo: "Valor máximo de pedidos da categoria"
      };
    }
  },
  created() {
    this.getData(this.$route.params.id);
  },
  methods: {
    getData(idcupom) {
      this.$store.dispatch(CUPOM_DESCONTO_LOAD, idcupom).then(resp => {
        this.cupom = {
          ...resp
        };
      });
    },
    extrairNomesCategorias(cupom = {}) {
      const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const nomeDeItem = item => {
        if (item == null || item === "") {
          return "";
        }
        if (typeof item === "object") {
          return (
            item.nome || item.rotulo || item.descricao || item.nome_setor || ""
          );
        }
        if (typeof item === "string" && !uuid.test(item)) {
          return item;
        }
        return "";
      };
      const nomesDeLista = value =>
        Array.isArray(value) ? value.map(nomeDeItem).filter(Boolean) : [];

      const deSetores = nomesDeLista(cupom.setores);
      if (deSetores.length) {
        return deSetores;
      }

      const deNomeSetores = nomesDeLista(cupom.nome_setores);
      if (deNomeSetores.length) {
        return deNomeSetores;
      }

      if (cupom.nome_setor) {
        return [cupom.nome_setor];
      }

      return [];
    },
    formatReal(v = "0") {
      return `${parseFloat(v).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    },
    onClose() {
      this.$emit("close");
    },
    endpoint(type) {
      const typeEndPoint = {
        cliente: `/api/v2/cupom-desconto/idcupom/${this.$route.params.id}/clientes`,
        pagamento: `/api/v2/cupom-desconto/idcupom/${this.$route.params.id}/idfornecedor/${this.getFornecedorId}/formasdepagamento`
      };

      return typeEndPoint[type];
    }
  }
};
</script>
